export enum ShopProductDocumentTypes {
  TERMS = 'TERMS',
  PRODUCT_DESCRIPTION = 'PRODUCT_DESCRIPTION',
  ORDER_FORM = 'ORDER_FORM',
}
